/**
 * Muertos cart helpers: week-pass covers every day; room covers the gathering.
 */
(function () {
  const cfg = () => window.SACBE_MUERTOS || {};

  function setFrom(list, fallback) {
    if (list && list.length) return new Set(list);
    return new Set(fallback || []);
  }

  function classify(handle) {
    const c = cfg();
    if (handle === c.weekPassHandle || handle === 'living-altar-week-pass') return 'week';
    if (handle === c.dayPassHandle || handle === 'living-altar-day-pass') return 'day';
    if (setFrom(c.roomHandles, c.fallbackRoomHandles).has(handle)) return 'room';
    if (setFrom(c.addonHandlesFromCollection, c.fallbackAddonHandles).has(handle)) return 'addon';
    return 'other';
  }

  function analyze(cart) {
    let hasRoom = false;
    let hasWeek = false;
    let hasDay = false;
    let hasAddon = false;
    for (const item of cart.items || []) {
      const kind = classify(item.handle);
      if (kind === 'room') hasRoom = true;
      else if (kind === 'week') hasWeek = true;
      else if (kind === 'day') hasDay = true;
      else if (kind === 'addon') hasAddon = true;
    }
    return { hasRoom, hasWeek, hasDay, hasAddon };
  }

  function calloutHtml(flags) {
    const c = cfg().callouts || {};
    if (flags.hasRoom) return c.room || '';
    if (flags.hasWeek && flags.hasDay) return c.covered || '';
    if (flags.hasWeek) return c.week || '';
    if (flags.hasDay) return c.day || '';
    return '';
  }

  function ensureHost() {
    let host = document.querySelector('[data-sacbe-muertos-callout]');
    if (host) return host;
    const cart = document.querySelector('cart-drawer, #CartDrawer, .cart-drawer, #main-cart-items, cart-items');
    if (!cart) return null;
    host = document.createElement('div');
    host.setAttribute('data-sacbe-muertos-callout', 'true');
    host.className = 'sacbe-muertos-notice';
    cart.prepend(host);
    return host;
  }

  async function refresh() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const html = calloutHtml(analyze(cart));
      const host = ensureHost();
      if (!host) return;
      host.hidden = !html;
      host.innerHTML = html || '';
    } catch (e) {
      /* cart page may not exist yet */
    }
  }

  window.SACBE_MUERTOS_CART = {
    classify,
    analyze,
    refresh,
    addItems: async function (items) {
      if (!items.length) return;
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items }),
      });
      await refresh();
      if (typeof window.refreshCart === 'function') window.refreshCart();
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    },
  };

  document.addEventListener('DOMContentLoaded', refresh);
})();
